export default "__VITE_ASSET__CCXtRzL___"